import { defineMessages } from '@alltrails/shared/react-intl';
import Button from '@alltrails/shared/denali/components/Button';
import useLanguageCode from 'hooks/useLanguageCode';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import * as styles from './styles/styles.module.scss';

const HELP_BUTTON_MESSAGES = defineMessages({
  HELP: {
    defaultMessage: 'Need help?'
  }
});

const HelpButton = (): JSX.Element => {
  const {
    formattedDefaultMessages: { HELP }
  } = useFormatMessage(HELP_BUTTON_MESSAGES);
  const languageCode = useLanguageCode();
  const supportLink = `https://support.alltrails.com/hc/${languageCode}/articles/360019245911-How-do-I-create-a-map-`;

  return (
    <Button
      className={styles.helpButton}
      linkInfo={{ href: supportLink, target: '_blank', rel: ['noreferrer'] }}
      onClick={() => {
        /* do nothing */
      }}
      text={HELP}
      testId="map-creator-help"
      variant="elevated"
    />
  );
};

export default HelpButton;
